import { Sha256 } from '@aws-crypto/sha256-js';

export const sha256Hex = (value: string): string => {
  const hash = new Sha256();

  hash.update(value);

  return Array.from(hash.digestSync(), (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('');
};
